import dayjs from 'dayjs';

export const getYearOptions = () => {
  const currentYear = dayjs().year();
  const yearRange: { label: string; value: number }[] = [];
  for (let year = currentYear - 10; year <= currentYear + 10; year++) {
    yearRange.push({
      label: year.toString(),
      value: year,
    });
  }

  return yearRange;
};

const months = [
  '一月',
  '二月',
  '三月',
  '四月',
  '五月',
  '六月',
  '七月',
  '八月',
  '九月',
  '十月',
  '十一月',
  '十二月',
];

export const getMonthOptions = () => {
  const monthOptions = months.map((month, index) => {
    return { label: month, value: index };
  });

  return monthOptions;
};
